import Phaser from 'phaser';
import BaseScene from './BaseScene';
import Level from '../components/Level';
import ButtonSprite from '../components/ButtonSprite';

export default class LevelSelector extends BaseScene {
    public maxLevelFinished = 0;
    private cameraScrollY: any;
    private scrollVelocityY: number;
    private dampingFactor: number;
    private dragEndVelocityY: number;
    private levels: Level[];
    private cam?: Phaser.Cameras.Scene2D.Camera;

    constructor() {
        super({key: 'LevelSelector'});
        this.scrollVelocityY = 0.1;
        this.dampingFactor = 0.95;
        this.dragEndVelocityY = 0;
        this.levels = [];
    }

    init(): void {
        super.init();
        this.maxLevelFinished = this.getBootloaderScene().AppData.totals.maxLevelFinished;  
        this.cameraScrollY = this.getBootloaderScene().globals.scenes.levelSelector.cameraScrollY;
    }

    create(): void {
        super.create();

        // Music
        this.getBootloaderScene().soundManager.playMainMenuMusic();  

        // BG
        const bg = this.add.image(this.width / 2, this.height / 2, 'level_selector_bg').setOrigin(.5);
        this.forceSpriteNotScaleY(bg);
        this.setImmobileSprite(bg);

        // Map
        const map = this.add.image(this.screenWidth / 2, (this.height / 2) -30, 'level_selector_map_01').setOrigin(0.5).setScrollFactor(0,1).setScale(2);

        // Levels
        this.levels = [
            new Level(this, 90, 3230, 1),
            new Level(this, 240, 3205, 2),
            new Level(this, 440, 3215, 3),
            new Level(this, 420, 3110, 4),
            new Level(this, 260, 3005, 5),
            new Level(this, 370, 2880, 6),
            new Level(this, 80, 2840, 7),
            new Level(this, 125, 2690, 8),
            new Level(this, 265, 2620, 9),
            new Level(this, 405, 2515, 10),
            new Level(this, 425, 2365, 11),
            new Level(this, 420, 2220, 12),
            new Level(this, 250, 2250, 13),
            new Level(this, 65, 2250, 14),
            new Level(this, 165, 2155, 15),
            new Level(this, 345, 2105, 16),
            new Level(this, 245, 2015, 17),
            new Level(this, 85, 1945, 18),
            new Level(this, 185, 1905, 19),
            new Level(this, 385, 1885, 20),
            new Level(this, 455, 1705, 21),
            new Level(this, 475, 1505, 22),
            new Level(this, 460, 1255, 23),
            new Level(this, 380, 1145, 24),
            new Level(this, 330, 1400, 25),
            new Level(this, 270, 1600, 26),
            new Level(this, 160, 1730, 27),
            new Level(this, 100, 1530, 28),
            new Level(this, 110, 1330, 29),
            new Level(this, 100, 1130, 30),
            new Level(this, 120, 930, 31),
            new Level(this, 180, 760, 32),
            new Level(this, 460, 680, 33),
            new Level(this, 150, 600, 34),
            new Level(this, 150, 420, 35),
            new Level(this, 140, 250, 36),
            new Level(this, 340, 220, 37),
            new Level(this, 170, 70, 38),
            new Level(this, 250, -70, 39),
            new Level(this, 390, -100, 40),
            new Level(this,450, -250, 41),
            new Level(this,250, -300, 42),
            new Level(this,130, -320, 43),
            new Level(this,300, -400, 44),
            new Level(this,450, -450 , 45),
            new Level(this,310, -520 , 46),
            new Level(this,110, -550 , 47),
            new Level(this,210, -630 , 48),
            new Level(this,330, -730 , 49),
            new Level(this,410, -880 , 50),
            new Level(this,450, -1050 , 51),
            new Level(this,450, -1260 , 52),
            new Level(this,350, -1140 , 53),
            new Level(this,250, -1000 , 54),
            new Level(this,200, -860 , 55),
            new Level(this,100, -720 , 56),
            new Level(this,80, -900 , 57),
            new Level(this,110, -1100 , 58),
            new Level(this,180, -1300 , 59),
            new Level(this,300, -1420 , 60),
            new Level(this,420, -1430 , 61),
            new Level(this,460, -1610 , 62),
            new Level(this,320, -1660 , 63),
            new Level(this,120, -1700 , 64),
            new Level(this,120, -1870 , 65),
            new Level(this,140, -2000 , 66),
            new Level(this,280, -1980 , 67),
            new Level(this,430, -1930 , 68),
            new Level(this,400, -2100 , 69),
            new Level(this,320, -2250 , 70),
        ];

        // Bottom Panel
        const bottomPanel = this.add.image(0, 0, 'gui_bottom_panel_medium').setOrigin(.5);
        const backButton = new ButtonSprite(this, 0, 0, 'button_back', 2, () => this.backButton()).setScale(0.8);
        const bottomPanelContainer = this.add.container(bottomPanel.width / 2, this.height - 54).add([bottomPanel, backButton]);
        this.setImmobileSprite(bottomPanelContainer);
        this.forceSpriteBottomPosition(bottomPanelContainer, 0);

        // Camera
        this.cam = this.cameras.main.setBounds(-this.screenWidth / 2, -2500, this.screenWidth * 2, 5900);
        this.initCameraScrollY(this.cam);

        // Camera Movement On Drag Map
        map.setInteractive({ useHandCursor: true });
        this.input.setDraggable(map);
        map.on('drag', (pointer: any) => {
            if(this.cam) {
                this.cam.scrollY -= pointer.velocity.y * this.scrollVelocityY;
                this.getBootloaderScene().globals.scenes.levelSelector.cameraScrollY = this.cam.scrollY;
            }
        }).on('dragend', (pointer: any) => {
            this.dragEndVelocityY = pointer.velocity.y;
        });
    }
    
    private initCameraScrollY(cam: Phaser.Cameras.Scene2D.Camera): void {
        if(this.cameraScrollY) {
            cam.setScroll(cam.scrollX, this.cameraScrollY);
            return;
        } 

        const level = this.getLevelById(this.maxLevelFinished + 1);
        if(level) {
            cam.centerOnY(level.y);
        }    
    }

    private getLevelById(levelId: number): Level | null {
        const level = this.levels.find(level => level.getLevelId() === levelId);
        if (!level) {
            return null;
        }
        return level;
    }

    private backButton(): void {
        this.getBootloaderScene().launchScene('MainMenu');
    }

    public update(): void {
        // Damping Effect
        if(Math.abs(this.dragEndVelocityY) > 0.1) {
            if(this.cam) {
                this.cam.scrollY -= this.dragEndVelocityY;
                this.dragEndVelocityY *= this.dampingFactor;
                this.getBootloaderScene().globals.scenes.levelSelector.cameraScrollY = this.cam.scrollY;
            }
        }
    }
}